import { createEnv } from "@t3-oss/env-core";
import { z } from "zod";

export const env = createEnv({
  clientPrefix: "VITE_",
  client: {
    // Empty string = same-origin (for proxy mode), URL = direct API access
    VITE_SERVER_URL: z.union([z.literal(""), z.url()]),
    VITE_SENTRY_DSN: z.string().optional(),
  },
  runtimeEnv: (import.meta as any).env,
});
